import React from 'react';
import { TextField } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import "./style.css";


export default (props) => {
  const [value, setValue] = React.useState(props.value);

  React.useEffect(() => {
    setValue(props.value)
  }, [props.value])

  const handleChange = (e) => {
    setValue(e.target.value);
    if (typeof props.onInput === "function") {
      props.onInput(e);
    }
  }


  return <TextField {...props} helperText={props.getHelperText ? props.getHelperText(value) : null} onChange={handleChange} onBlur={props.onChange} value={value}
  />
}
